import { render } from "./down-time.vue?vue&type=template&id=843dbc4a"
import script from "./down-time.vue?vue&type=script&lang=js"
export * from "./down-time.vue?vue&type=script&lang=js"

import "./down-time.vue?vue&type=style&index=0&id=843dbc4a&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__